<template>
  <el-popover
    ref="Popover"
    v-model="visible"
    placement="bottom-start"
    width="400"
    trigger="click"
    @show="loadFamily"
  >
    <template #reference>
      <div class="tw-relative">
        <div
          v-if="visible"
          class="tw-fixed tw-inset-0"
          @click.stop="visible = false"
        />
        <slot />
        <i-badge
          v-if="showMessagesCount && countMessages"
          type="primary"
          is-circle
          class="tw-absolute tw-z-10 tw--top-1.5 tw--right-1.5 tw-border-2 tw-border-light dark:tw-border-dm-light"
        >
          {{ countMessages }}
        </i-badge>
      </div>
    </template>

    <div class="tw-divide-y tw-divide-gray dark:tw-divide-dm-gray tw-px-6 tw-py-4">
      <ForeignerFamilyPopoverListItem
        v-for="person in family"
        :key="person.relation_with_id"
        :person="person"
        :link="link"
        :redirect-on-click="redirectOnFamilyMemberClick"
        :store-path="storePath"
        @family-member-click="$emit('family-member-click', person.relation_with_id)"
      />
    </div>

    <slot name="footer" />
  </el-popover>
</template>

<script>
import ForeignerFamilyPopoverListItem from './ForeignerFamilyPopoverListItem.vue';

export default {
  components: {
    ForeignerFamilyPopoverListItem,
  },
  props: {
    family: {
      type: Object,
      required: true,
    },
    foreignerId: {
      type: Number,
      required: true,
    },
    showMessagesCount: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Function,
      default: (id) => `/foreigners/${id}`,
    },
    redirectOnFamilyMemberClick: {
      type: Boolean,
      default: true,
    },
    storePath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      timer: null,
      visible: false,
    };
  },

  computed: {
    countMessages() {
      const pathArray = this.storePath.split('/');
      let stateFragment = this.$store.state;
      pathArray.forEach((path) => {
        stateFragment = stateFragment[path];
      });
      return stateFragment.family.filter(({ foreigner_id }) => String(foreigner_id) !== String(this.foreignerId)).reduce((total, { message_count }) => total + message_count, 0);
    },
  },

  mounted() {
    this.loadFamily();

    if (this.showMessagesCount) {
      this.timer = setInterval(() => {
        if (this.foreignerId) {
          this.loadFamily();
        }
      }, 30 * 1000);
    }
  },

  beforeUnmount() {
    clearInterval(this.timer);
  },

  methods: {
    async loadFamily() {
      await this.$store.dispatch(`${this.storePath}/loadFamilyMessagesCount`, this.foreignerId);
    },
  },
};
</script>
